<template>
  <div class="AboutUsBar">
    <el-menu
        class="el-menu-vertical-demo"
        @select="handleSelect"
        :default-active="RoutePath"
        router
        mode="horizontal"
        active-text-color="#409EFF"
    >
      <el-menu-item :index="item.name" v-for="(item,index) in AboutUsBarList" :key="index">
<!--        <i class="el-icon-setting"></i>-->
        <span slot="title">{{ item.AboutUsBarItem }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: 0,
      AboutUsBarList:[
        {
          name:'/Community/CompanyProfile',
          AboutUsBarItem:'公司简介',
        },
        {
          name:'/Community/HonoraryCertificate',
          AboutUsBarItem:'荣誉资质'
        },
        {
          name:'/Community/DataDownload',
          AboutUsBarItem:'资料下载'
        },
        {
          name:'/Community/EnterpriseCulture',
          AboutUsBarItem:'企业文化'
        },
        {
          name:'/Community/ContactUs',
          AboutUsBarItem:'联系我们'
        }
      ],
      RoutePath: this.$route.path,
    }
  },
  watch: {
    '$route' (to,from) {
      // 监听路由变化
      this.RoutePath = to.path
    }
  },
  methods:{
    handleSelect(key, keyPath){
      // console.log(key,keyPath)
      this.$emit('handleBarList',key,this.AboutUsBarList)
      // if (key == this.AboutUsBarList.name){
      //   this.$router.push({path:this.AboutUsBarList.name})
      // }
    },
  }
}
</script>
<style scoped>
.el-menu--horizontal >.el-menu-item.is-active {
  border-right: 1px solid #409EFF;
  border-bottom: none;
  /*background-color: red;*/
  background-image: linear-gradient(to right, #FFFFFF, rgba(64, 158, 255, 0.4));
}
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  text-align: center;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/views/components/AboutUsBar.vue